import theme from '@styles/theme';
export default {
  page: {
    backgroundColor: theme.rawColors.lightGrey300,
    minHeight: '60vh'
  },
  breadcrumbContainer: {
    margin: '0 auto',
    display: ['none', 'none', 'none', 'block']
  },
  formView: {
    margin: '0 auto',
    padding: ['24px 0px 48px', '24px 16px 48px', '40px 50px 64px', '40px 100px 64px', '40px 195px 64px']
  },
  formHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: ['24px', '24px', '32px']
  },
  formHeaderTitle: {
    margin: 0
  },
  formCard: {
    backgroundColor: theme.rawColors.neutralWhite,
    padding: ['24px 16px', '24px 20px', '32px 28px']
  },
  faqSection: {
    backgroundColor: theme.rawColors.neutralWhite
  },
  faqContainer: {}
};